import { EligibilityProvider } from "@/components/landing/EligibilityContext";
import { AnnouncementBar, Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { StatsBand } from "@/components/landing/StatsBand";
import { WhatMakesDifferent } from "@/components/landing/WhatMakesDifferent";
import { ClassInAction } from "@/components/landing/ClassInAction";
import { LocationCard } from "@/components/landing/LocationCard";
import { ProblemSection } from "@/components/landing/ProblemSection";
import { SolutionSection } from "@/components/landing/SolutionSection";
import { Curriculum } from "@/components/landing/Curriculum";
import { Testimonials } from "@/components/landing/Testimonials";
import { PromiseSection } from "@/components/landing/PromiseSection";
import { BatchCountdown } from "@/components/landing/BatchCountdown";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { Footer } from "@/components/landing/Footer";
import { StickyMobileBar } from "@/components/landing/StickyMobileBar";

export default function Landing() {
  return (
    <EligibilityProvider>
      <div className="min-h-screen bg-ink text-offwhite" data-testid="landing-page">
        <AnnouncementBar />
        <Navbar />
        <main className="pb-24 md:pb-0">
          <Hero />
          <StatsBand />
          <WhatMakesDifferent />
          <ClassInAction />
          <LocationCard />
          <ProblemSection />
          <SolutionSection />
          <Curriculum />
          <Testimonials />
          <PromiseSection />
          <BatchCountdown />
          <FinalCTA />
        </main>
        <Footer />
        <StickyMobileBar />
      </div>
    </EligibilityProvider>
  );
}
